import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
  Link,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));



const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données hiérarchisées
const populationData = {
  title: "Répartition de la population des ménages collectifs par province et commune selon le sexe",
  provinces: [
    {
      name: "BUHUMUZA",
      communes: [
        { name: "BUTAGANZWA", masculin: "92", feminin: "7", total: "99", proportion: "0,1" },
        { name: "BUTIHINDA", masculin: "508", feminin: "386", total: "894", proportion: "0,8" },
        { name: "CANKUZO", masculin: "967", feminin: "417", total: "1 384", proportion: "1,3" },
        { name: "GISAGARA", masculin: "363", feminin: "234", total: "597", proportion: "0,5" },
        { name: "GISURU", masculin: "611", feminin: "437", total: "1 048", proportion: "1,0" },
        { name: "MUYINGA", masculin: "2 749", feminin: "1 016", total: "3 765", proportion: "3,4" },
        { name: "RUYIGI", masculin: "1 960", feminin: "984", total: "2 944", proportion: "2,7" }
      ],
      masculin: "7 250",
      feminin: "3 481",
      total: "10 731",
      proportion: "9,8"
    },
    {
      name: "BUJUMBURA",
      communes: [
        { name: "BUBANZA", masculin: "2 856", feminin: "1 147", total: "4 003", proportion: "3,7" },
        { name: "BUKINANYANA", masculin: "1 180", feminin: "284", total: "1 464", proportion: "1,3" },
        { name: "CIBITOKE", masculin: "1 280", feminin: "333", total: "1 613", proportion: "1,5" },
        { name: "ISARE", masculin: "189", feminin: "57", total: "246", proportion: "0,2" },
        { name: "MPANDA", masculin: "2 528", feminin: "757", total: "3 285", proportion: "3,0" },
        { name: "MUGERE", masculin: "3 873", feminin: "1 362", total: "5 235", proportion: "4,8" },
        { name: "MUGINA", masculin: "475", feminin: "97", total: "572", proportion: "0,5" },
        { name: "MUHUTA", masculin: "20", feminin: "13", total: "33", proportion: "0,0" },
        { name: "MUKAZA", masculin: "6 788", feminin: "2 183", total: "8 971", proportion: "8,2" },
        { name: "NTAHANGWA", masculin: "11 455", feminin: "2 941", total: "14 396", proportion: "13,1" },
        { name: "RWIBAGA", masculin: "243", feminin: "677", total: "920", proportion: "0,8" }
      ],
      masculin: "30 887",
      feminin: "9 851",
      total: "40 738",
      proportion: "37,2"
    },
    {
      name: "BURUNGA",
      communes: [
        { name: "BURURI", masculin: "5 094", feminin: "1 933", total: "7 027", proportion: "6,4" },
        { name: "MAKAMBA", masculin: "1 405", feminin: "556", total: "1 961", proportion: "1,8" },
        { name: "MATANA", masculin: "2 161", feminin: "1 219", total: "3 380", proportion: "3,1" },
        { name: "MUSONGATI", masculin: "609", feminin: "582", total: "1 191", proportion: "1,1" },
        { name: "NYANZA", masculin: "2 548", feminin: "428", total: "2 976", proportion: "2,7" },
        { name: "RUMONGE", masculin: "2 010", feminin: "261", total: "2 271", proportion: "2,1" },
        { name: "RUTANA", masculin: "1 259", feminin: "564", total: "1 823", proportion: "1,7" }
      ],
      masculin: "15 086",
      feminin: "5 543",
      total: "20 629",
      proportion: "18,8"
    },
    {
      name: "BUTANYERERA",
      communes: [
        { name: "BUSONI", masculin: "393", feminin: "154", total: "547", proportion: "0,5" },
        { name: "KAYANZA", masculin: "1 510", feminin: "579", total: "2 089", proportion: "1,9" },
        { name: "KIREMBA", masculin: "445", feminin: "304", total: "749", proportion: "0,7" },
        { name: "KIRUNDO", masculin: "1 037", feminin: "541", total: "1 578", proportion: "1,4" },
        { name: "MATONGO", masculin: "620", feminin: "537", total: "1 157", proportion: "1,1" },
        { name: "MUHANGA", masculin: "56", feminin: "70", total: "126", proportion: "0,1" },
        { name: "NGOZI", masculin: "3 026", feminin: "1 326", total: "4 352", proportion: "4,0" },
        { name: "TANGARA", masculin: "452", feminin: "287", total: "739", proportion: "0,7" }
      ],
      masculin: "7 539",
      feminin: "3 798",
      total: "11 337",
      proportion: "10,3"
    },
    {
      name: "GITEGA",
      communes: [
        { name: "BUGENDANA", masculin: "568", feminin: "528", total: "1 096", proportion: "1,0" },
        { name: "GISHUBI", masculin: "404", feminin: "376", total: "780", proportion: "0,7" },
        { name: "GITEGA", masculin: "7 435", feminin: "6 223", total: "13 658", proportion: "12,5" },
        { name: "KARUSI", masculin: "533", feminin: "348", total: "881", proportion: "0,8" },
        { name: "KIGANDA", masculin: "415", feminin: "482", total: "897", proportion: "0,8" },
        { name: "MURAMVYA", masculin: "2 917", feminin: "1 978", total: "4 895", proportion: "4,5" },
        { name: "MWARO", masculin: "2 720", feminin: "880", total: "3 600", proportion: "3,3" },
        { name: "NYABIHANGA", masculin: "87", feminin: "45", total: "132", proportion: "0,1" },
        { name: "SHOMBO", masculin: "131", feminin: "98", total: "229", proportion: "0,2" }
      ],
      masculin: "15 210",
      feminin: "10 958",
      total: "26 168",
      proportion: "23,9"
    }
  ],
  total: {
    masculin: "75 972",
    feminin: "33 631",
    total: "109 603",
    proportion: "100,0"
  }
};

const PopulationCollectiveHouseholdsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };
  const filteredProvinces = populationData.provinces.map(province => {
    if (!searchTerm) return province;
    
    const filteredCommunes = province.communes.filter(commune =>
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    return {
      ...province,
      communes: filteredCommunes,
      show: filteredCommunes.length > 0 || 
            province.name.toLowerCase().includes(searchTerm.toLowerCase())
    };
  }).filter(province => province.show || !searchTerm);

// Calcul des indicateurs clés
const keyStats = {
  totalPopulation: populationData.total.total,

  womenPercentage: (
    (parseFloat(populationData.total.feminin.replace(/\s/g, '')) / 
     parseFloat(populationData.total.total.replace(/\s/g, ''))) * 100
  ).toFixed(1),

  mostPopulousProvince: populationData.provinces.reduce((max, province) => 
    parseFloat(province.total.replace(/\s/g, '')) > parseFloat(max.total.replace(/\s/g, '')) ? province : max
  ),

  leastPopulousProvince: populationData.provinces.reduce((min, province) => 
    parseFloat(province.total.replace(/\s/g, '')) < parseFloat(min.total.replace(/\s/g, '')) ? province : min
  ),

  highestWomenPercentage: populationData.provinces.reduce((max, province) => {
    const womenPct = (
      parseFloat(province.feminin.replace(/\s/g, '')) / 
      parseFloat(province.total.replace(/\s/g, ''))
    ) * 100;
    return womenPct > max.womenPct ? { province, womenPct } : max;
  }, { province: null, womenPct: 0 }),

  highestGenderGap: populationData.provinces.reduce((max, province) => {
    const gap = Math.abs(
      (parseFloat(province.masculin.replace(/\s/g, '')) - 
       parseFloat(province.feminin.replace(/\s/g, ''))) / 
      parseFloat(province.total.replace(/\s/g, '')) * 100
    );
    return gap > max.gap ? { province, gap } : max;
  }, { province: null, gap: 0 })
};
  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );


  return (
     <MainContainer>
          <CssBaseline />
          <NavigationBar />
          <MainContentWithDrawer>
            {!isMobile ? (
              <DrawerWrapper>
                {drawer}
              </DrawerWrapper>
            ) : (
              <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: true,
                }}
                sx={{
                  '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
              >
                {drawer}
              </Drawer>
            )}
    
            <ContentWrapper>
              <Container maxWidth="lg">
                {isMobile && (
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                    <Button 
                      variant="outlined" 
                      startIcon={<MenuIcon />} 
                      onClick={handleDrawerToggle}
                      sx={{ color: primaryColor, borderColor: primaryColor }}
                    >
                      Menu
                    </Button>
                  </Box>
                )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {populationData.title}
                    </Typography>
                  </Box>
                    <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                         <Grid item xs={12} sm={6} md={6} ></Grid>
                         <Grid item xs={12} sm={6} md={6}>
                   <TextField
                      size="small"
                      placeholder="Rechercher province/commune..."
                      variant="outlined"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: { xs: '100%', sm: '480px' } }}
                    />
                    </Grid>
                    </Grid>
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés par Province
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Totale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {populationData.total.total}
                              </Typography>
                              <Typography variant="caption">
                                Ménages collectifs
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Proportion Femmes
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.womenPercentage}%
                              </Typography>
                              <Typography variant="caption">
                                Moyenne nationale
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Province la plus peuplée
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulousProvince.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulousProvince.total}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({keyStats.mostPopulousProvince.proportion}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus forte proportion femmes
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.highestWomenPercentage.province.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.highestWomenPercentage.womenPct.toFixed(1)}%
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Proportion (%)</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.masculin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.feminin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.proportion}</TableCell>
                        </ProvinceRow>

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.name)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{province.masculin}</TableCell>
                              <TableCell align="right">{province.feminin}</TableCell>
                              <TableCell align="right">{province.total}</TableCell>
                              <TableCell align="right">{province.proportion}</TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={5}>
                                <Collapse in={expandedProvinces[province.name] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune, idx) => (
                                        <CommuneRow key={idx} hover>
                                          <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                          <TableCell align="right">{commune.masculin}</TableCell>
                                          <TableCell align="right">{commune.feminin}</TableCell>
                                          <TableCell align="right">{commune.total}</TableCell>
                                          <TableCell align="right">{commune.proportion}</TableCell>
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* 
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos des ménages collectifs
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Les ménages collectifs comprennent les personnes vivant dans des institutions telles que:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• Établissements pénitentiaires" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Casernes militaires" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Internats scolaires" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Hôpitaux et centres de soins de longue durée" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Monastères et couvents" 
                        />
                      </ListItem>
                    </List>
                    <Typography variant="body2" mt={2}>
                      Ces données représentent environ {populationData.total.total} personnes, soit {populationData.total.proportion}% de la population totale du Burundi.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et Elevage (RGPHAE) 
                    réalisé en 2024. Les chiffres incluent uniquement la population des ménages collectifs. 
                    Les proportions sont calculées par rapport au total national des ménages collectifs.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationCollectiveHouseholdsPage;